export default __webpack_public_path__ + "static/media/number3.5b0f33f4.svg";